import $ from 'jquery';

// Use tradera/components/breakpoint/breakpoint instead!

//TODO - Change this to use media query events.
function isVisible(breakpoint) {
    return $(breakpoint).css('display') === 'block';
}
function getCurrent() {
    const sizes = ['xxlarge', 'xlarge', 'large', 'medium', 'small'];
    // eslint-disable-next-line better-mutation/no-mutation
    for (let i = 0; i < sizes.length; i++) {
        const breakpoint = '#breakpoint-' + sizes[i];
        if (isVisible(breakpoint)) {
            return sizes[i];
        }
    }
}

export default {
    isVisible: isVisible,
    getCurrent: getCurrent,
    small: '#breakpoint-small',
    medium: '#breakpoint-medium',
    large: '#breakpoint-large',
    xlarge: '#breakpoint-xlarge',
    xxlarge: '#breakpoint-xxlarge',
    siteheader: '#breakpoint-siteheader',
    siteheaderportrait: '#breakpoint-siteheaderportrait',
    sidebarsearch: '#breakpoint-sidebarsearch'
};
